var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWindowsAppIconWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.357143,
    y: 0.357143,
    width: 15.2857,
    height: 15.2857,
    rx: 0.642857,
    stroke: "white",
    strokeWidth: 0.714286
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3H8.49996V7.49994H13V4C13 3.44772 12.5523 3 12 3ZM13 8.49994H8.49996V13H12C12.5523 13 13 12.5523 13 12V8.49994ZM7.49996 7.49994V3H4C3.44772 3 3 3.44772 3 4V7.49994H7.49996ZM3 8.49994H7.49996V13H4C3.44772 13 3 12.5523 3 12V8.49994Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWindowsAppIconWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/windows-app-icon_white.a690eeed616b741e06b018678c5b00f1.svg";